<template>
  <div class="the-navbar__user-meta flex items-center mr-4">
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >
      <vs-button type="line">
        ACCOUNT : {{ activeAccountInfo.name }}
      </vs-button>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <vs-dropdown-item>
          <vs-button
            icon="add"
            @click="addAccountForm()"
          >
            アカウント追加
          </vs-button>
        </vs-dropdown-item>
        <vs-dropdown-item
          v-for="(account, index) in accountsInfo"
          :key="index"
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
        >
          <span @click="setAccount(account)" class="flex">
            <VueFeather
              type="home"
              class="feather-icon feather-icon-css-target inline-flex"
            />
            <span class="ml-2">{{ account.name }}</span>
          </span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <form-modal
      v-model="showForm"
      title="アカウント追加"
      @click:submit="onClickSubmit"
    >
      <template #content>
        <ValidationForm ref="accountNameObserver">
          <seller-create-account-form
            v-model:accountName="accountName"
            class="mb-4"
          />
        </ValidationForm>
      </template>
    </form-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import FormModal from '@/components/modals/FormModal'
import SellerCreateAccountForm from '@/components/forms/SellerCreateAccountForm'

export default {
  components: {
    FormModal,
    SellerCreateAccountForm
  },
  data () {
    return {
      showForm: false,
      showConfirmModal: false,
      confirmMessage: null,
      accountName: '',
      newAccountsInfo: []
    }
  },
  computed: {
    accountsInfo () {
      return this.$store.state.account.accounts
    },
    activeAccountInfo () {
      return this.$store.state.account.activeAccount
    },
    activeUserInfo () {
      return this.$store.state.auth.activeUser
    }
  },
  methods: {
    ...mapActions('account', ['addAccount']),
    ...mapActions('userAccounts', ['addUserAccounts']),
    ...mapActions('amcProfile', ['setAcitveAmcProfileByAccount']),
    ...mapMutations('account', ['SET_ACCOUNTS']),
    setAccount (data) {
      this.$store.dispatch('account/changeAccount', data)
      .then(this.setAcitveAmcProfileByAccount(data))
      .then(() => {
        this.$router.push('/').catch(() => {})
      }).catch(() => {
      })
    },
    addAccountForm () {
      this.showForm = true
    },
    async onClickSubmit () {
      try {
        const result = await this.$refs.accountNameObserver.validate()
        if (!result.valid) return
        const newAccount = await this.addAccount({name:this.accountName})
        const userAccount = {
          email: this.activeUserInfo,
          accountId: newAccount.data.data.id
        }
        await this.addUserAccounts(userAccount)
        this.newAccountsInfo = this.accountsInfo.map(v => v)
        this.newAccountsInfo.push(newAccount.data.data)
        this.SET_ACCOUNTS(this.newAccountsInfo)
        this.showForm = false
        this.accountName = ''
        this.$refs.accountNameObserver.resetForm()
        this.setAccount(newAccount.data.data)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss">
  .vs-dropdown--item a.vs-dropdown--item-link {
    display: flex;
    align-items: center;
  }
</style>

<style scoped>
.feather-icon-css-target :deep(.vue-feather__content) {
  width: 1rem !important;
  height: 1rem !important;
}
</style>
